export enum RidesKanbanSortEnum {
  UpdatedDesc = "UpdatedDesc",
  CreatedDesc = "CreatedDesc",
  AreaAsc = "AreaAsc",
}
